import { Box } from "../Box"
import * as styles from "./styles"
import { GAUGE_CIRCUMFERENCE, GAUGE_ROTATION } from "./const"

const startingDegree = GAUGE_ROTATION + 90
const dialOffsetPercent = 50 * (1 - Math.cos(((360 - GAUGE_CIRCUMFERENCE) * 3.14159) / 360))

type Props = {
  value: number
  max: number
}

export const Needle = ({ value, max }: Props) => {
  // Calculate the rotation of the needle
  const calculateNeedleRotation = (v: number) => startingDegree + (GAUGE_CIRCUMFERENCE / max) * v

  return (
    <Box css={styles.needle(dialOffsetPercent)}>
      <Box css={styles.needleDial(calculateNeedleRotation(value))}>
        <Box css={styles.needleArm}>
          <Box css={styles.needlePoint}>
            <svg viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.47278 0.84906L17.0721 12.4695L1.87349 12.4695L9.47278 0.84906Z" fill="#19282D" />
            </svg>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
